import { Modal } from "antd";
import { useEffect } from "react";

const Alerts = ({ setShowConfirmModal ,antTitle,antContent,antOkText,antCancelText,action=null,id=null,confirmMsgText,onConfirm=null}) => {

  useEffect(() => {
    console.log(action,"action")
  },[action])

  const showConfirm = () => {
    const modal = Modal.confirm({
      title: antTitle,//"Do you want to delete?"
      content: antContent,//"This action cannot be undone."
      okText: antOkText,//"Confirm Delete"
      cancelText:antCancelText,//"Cancel"
      centered: true,
      closable:true,
      maskClosable:true,
      onOk: () => {
        // Perform the delete action here
        console.log("Delete confirmed");
        if(action){
          action(id);
        }
        if(onConfirm){
          onConfirm()
        }
        setShowConfirmModal(false);
       
        Modal.success({
          title: "Success",
          content: confirmMsgText||"The action was completed successfully.",
          centered: true,
        });
      },
      onCancel: () => {
        console.log("Delete action was cancelled");
        setShowConfirmModal(false);
      },
    });

 

    // Clean up the modal when it's closed
    return () => modal.destroy();
  };

  // Trigger the modal when the component is mounted
  showConfirm();


};

export default Alerts;
